import { render, staticRenderFns } from "./PreviewImage.vue?vue&type=template&id=273137c5&scoped=true&lang=pug"
import script from "./PreviewImage.vue?vue&type=script&lang=js"
export * from "./PreviewImage.vue?vue&type=script&lang=js"
import style0 from "./PreviewImage.vue?vue&type=style&index=0&id=273137c5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273137c5",
  null
  
)

export default component.exports